import { render, staticRenderFns } from "./flights-details.vue?vue&type=template&id=66fdd852&"
import script from "./flights-details.vue?vue&type=script&lang=js&"
export * from "./flights-details.vue?vue&type=script&lang=js&"
import style0 from "./flights-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports